// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header__z8ezc {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.header_inner__HFewK {
  border-bottom: 1px solid rgba(243, 243, 243, 0.2);
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 24px;
  padding-top: 16px;
  height: 54px;
  padding-bottom: 12px;
  position: relative;
}
.header_chnace__beFZ\\+ {
  border-radius: 16px;
  background: #072926;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 2px;
  position: absolute;
  left: 24px;
}
.header_chnace__beFZ\\+ span {
  color: #fff;
  text-align: right;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding-top: 2px;
}
.header_chnace__beFZ\\+ img {
  width: 13px;
  height: 12px;
}
.header_title__j5wSX {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
}
.header_title__j5wSX span {
}
.header_back__VdNP7 {
  position: absolute;
  right: 24px;
}
.header_back__VdNP7 img {
}
.header_holder__4rDwj {
  width: 32px;
  height: 32px;
  position: absolute;
  left: 24px;
}
.header_result__N2RMF {
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px; /* 150% */
  position: absolute;
  right: 24px;
  cursor: pointer;
}
.header_nav__QGzOh {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 1200px) {
  .header_logo__wLirW {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
  .header_logo__wLirW span {
    color: #fff;
    text-align: center;
    /* font-family: "Yekan Bakh FaNum"; */
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .header_back__VdNP7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 56px;
    border: 1px solid rgba(255, 255, 255, 0.24);
    background: rgba(255, 255, 255, 0.12);
    box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),
      -67px 43px 32px 0px rgba(0, 3, 15, 0.01),
      -38px 24px 27px 0px rgba(0, 3, 15, 0.04),
      -17px 11px 20px 0px rgba(0, 3, 15, 0.07),
      -4px 3px 11px 0px rgba(0, 3, 15, 0.08);
    height: 48px;
    padding: 0px 16px 0px 24px;
  }
  .header_inner__HFewK {
    border-bottom: unset;
    background: unset;
    max-width: 1200px;
  }
  .header_header__z8ezc {
    padding-top: 40px;
  }
  .header_holder__4rDwj {
    width: 205px;
  }
  .header_title__j5wSX {
    font-size: 16px;
  }
  .header_chnace__beFZ\\+ span {
    font-size: 14px;
  }
  .header_result__N2RMF {
    border-radius: 72px;
    border: 2px solid rgba(255, 255, 255, 0.24);
    background: rgba(255, 255, 255, 0.16);

    /* Button Shadows */
    box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),
      0px 60px 24px 0px rgba(0, 0, 0, 0.01),
      0px 34px 20px 0px rgba(0, 0, 0, 0.05),
      0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    padding: 10px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px; /* 125% */
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iDAAiD;EACjD,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;AACA;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;AACA;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC;;;;4CAIwC;IACxC,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IAEE,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;;IAErC,mBAAmB;IACnB;;;+EAG2E;IAC3E,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;EACV;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.inner {\n  border-bottom: 1px solid rgba(243, 243, 243, 0.2);\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 8px 24px;\n  padding-top: 16px;\n  height: 54px;\n  padding-bottom: 12px;\n  position: relative;\n}\n.chnace {\n  border-radius: 16px;\n  background: #072926;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 8px;\n  gap: 2px;\n  position: absolute;\n  left: 24px;\n}\n.chnace span {\n  color: #fff;\n  text-align: right;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  padding-top: 2px;\n}\n.chnace img {\n  width: 13px;\n  height: 12px;\n}\n.title {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 21px;\n}\n.title span {\n}\n.back {\n  position: absolute;\n  right: 24px;\n}\n.back img {\n}\n.holder {\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  left: 24px;\n}\n.result {\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 21px; /* 150% */\n  position: absolute;\n  right: 24px;\n  cursor: pointer;\n}\n.nav {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n@media screen and (min-width: 1200px) {\n  .logo {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n  }\n  .logo span {\n    color: #fff;\n    text-align: center;\n    /* font-family: \"Yekan Bakh FaNum\"; */\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n  .back {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    border-radius: 56px;\n    border: 1px solid rgba(255, 255, 255, 0.24);\n    background: rgba(255, 255, 255, 0.12);\n    box-shadow: -105px 67px 35px 0px rgba(0, 3, 15, 0),\n      -67px 43px 32px 0px rgba(0, 3, 15, 0.01),\n      -38px 24px 27px 0px rgba(0, 3, 15, 0.04),\n      -17px 11px 20px 0px rgba(0, 3, 15, 0.07),\n      -4px 3px 11px 0px rgba(0, 3, 15, 0.08);\n    height: 48px;\n    padding: 0px 16px 0px 24px;\n  }\n  .inner {\n    border-bottom: unset;\n    background: unset;\n    max-width: 1200px;\n  }\n  .header {\n    padding-top: 40px;\n  }\n  .holder {\n    width: 205px;\n  }\n  .title {\n    font-size: 16px;\n  }\n  .chnace span {\n    font-size: 14px;\n  }\n  .result {\n    font-size: 16px;\n    border-radius: 72px;\n    border: 2px solid rgba(255, 255, 255, 0.24);\n    background: rgba(255, 255, 255, 0.16);\n\n    /* Button Shadows */\n    box-shadow: 0px 94px 26px 0px rgba(0, 0, 0, 0),\n      0px 60px 24px 0px rgba(0, 0, 0, 0.01),\n      0px 34px 20px 0px rgba(0, 0, 0, 0.05),\n      0px 15px 15px 0px rgba(0, 0, 0, 0.09), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);\n    padding: 10px;\n    color: #fff;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 450;\n    line-height: 20px; /* 125% */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_header__z8ezc`,
	"inner": `header_inner__HFewK`,
	"chnace": `header_chnace__beFZ+`,
	"title": `header_title__j5wSX`,
	"back": `header_back__VdNP7`,
	"holder": `header_holder__4rDwj`,
	"result": `header_result__N2RMF`,
	"nav": `header_nav__QGzOh`,
	"logo": `header_logo__wLirW`
};
export default ___CSS_LOADER_EXPORT___;
